if(!customElements.get('bonjoer-countdown')){
  customElements.define('bonjoer-countdown',class extends HTMLElement{
    connectedCallback(){
      this.campaign=this.closest('[data-bj-campaign-countdown]');
      this.storageKey='bonjoer:campaign-dismissed:'+this.dataset.end;
      this.closeButton=this.campaign?.querySelector('[data-bj-campaign-close]');
      this.dismiss=()=>{
        if(this.campaign)this.campaign.hidden=true;
        clearInterval(this.interval);
        try{sessionStorage.setItem(this.storageKey,'1');}catch{}
      };
      try{if(!window.Shopify?.designMode&&sessionStorage.getItem(this.storageKey)==='1'){this.campaign.hidden=true;return;}}catch{}
      if(this.closeButton){this.closeButton.hidden=false;this.closeButton.addEventListener('click',this.dismiss);}
      this.finish=Date.parse(this.dataset.end);
      this.update();
      clearInterval(this.interval);
      if(!this.hidden)this.interval=setInterval(()=>this.update(),30000);
    }
    disconnectedCallback(){clearInterval(this.interval);this.closeButton?.removeEventListener('click',this.dismiss);}
    update(){
      const left=this.finish-Date.now();
      if(!Number.isFinite(left)||left<=0){this.hidden=true;this.closest('[data-bj-campaign-countdown]')?.setAttribute('hidden','');clearInterval(this.interval);return;}
      const total=Math.floor(left/60000);
      const values={days:Math.floor(total/1440),hours:Math.floor(total%1440/60),minutes:total%60};
      for(const [key,value] of Object.entries(values)){
        const node=this.querySelector('[data-'+key+']');
        if(node&&node.textContent!==String(value))node.textContent=String(value);
      }
    }
  });
}

